import ymaps from 'yandex-maps'

type DrawPolygonParams = {
    id?: string
    coordinates: number[][]
    color: string
    hintContent: string | null
}

export default function () {
    const createPolygon = (params: DrawPolygonParams): ymaps.Polygon => {
        return new window.ymaps.Polygon(
            [params.coordinates],
            { hintContent: params.hintContent, id: params.id },
            {
                strokeOpacity: 0.2,
                strokeWidth: 0,
                fillOpacity: 0.2,
                strokeColor: params.color,
                fillColor: params.color,
                zIndexHover: 0,
            }
        )
    }

    function getPolygonCentroid(coordinates: number[][]): number[] {
        const latitudes: number[] = coordinates.map((crds) => crds[0])
        const longitudes: number[] = coordinates.map((crds) => crds[1])

        const latitudes_sum: number = latitudes.reduce((partialSum, a) => partialSum + a, 0)
        const longitudes_sum: number = longitudes.reduce((partialSum, a) => partialSum + a, 0)

        const centroid = [latitudes_sum / latitudes.length, longitudes_sum / longitudes.length]
        return centroid
    }

    function startUpdatePolygonByIndex(map: ymaps.Map, polygon_index: number): void {
        const polygon = map.geoObjects.get(polygon_index) as any
        polygon.editor.startEditing()
    }

    function getPolygonById(map: ymaps.Map, polygon_id: string): ymaps.Polygon | null {
        for (let i = 0; i < map.geoObjects.getLength(); i++) {
            const obj = map.geoObjects.get(i) as ymaps.GeoObject

            // @ts-ignore
            if (obj.properties.get('id') === polygon_id) {
                return obj as ymaps.Polygon
            }
        }

        return null
    }

    function startUpdatePolygonById(map: ymaps.Map, polygon_id: string): void {
        const polygon = getPolygonById(map, polygon_id)
        
        if (polygon) {
            polygon.editor.startEditing()
        }
    }

    function stopUpdatePolygonByIndex(map: ymaps.Map, polygon_index: number): void {
        const polygon = map.geoObjects.get(polygon_index) as any
        polygon.editor.stopEditing()
    }

    function stopUpdatePolygonById(map: ymaps.Map, polygon_id: string): void {
        const polygon = getPolygonById(map, polygon_id)
        
        if (polygon) {
            polygon.editor.stopEditing()
        }
    }

    function updatePolygonByIndex(
        map: ymaps.Map,
        polygon_index: number,
        params: { name?: string; color?: string }
    ): void {
        const polygon = map.geoObjects.get(polygon_index) as any

        if (params.color) {
            polygon.options.set('fillColor', params.color)
            polygon.options.set('strokeColor', params.color)
        }

        if (params.name) {
            polygon.properties.set('hintContent', params.name)
        }
    }

    function removePolygonByIndex(map: ymaps.Map, polygon_index: number): void {
        map.geoObjects.splice(polygon_index, 1)
    }

    function getActualPolygonCoordinatesByIndex(map: ymaps.Map, polygon_index: number): number[][] {
        const polygon = map.geoObjects.get(polygon_index) as any
        return polygon.geometry.getCoordinates()[0]
    }

    function getActualPolygonCoordinatesById(map: ymaps.Map, polygon_id: string): number[][] | null {
        const polygon = getPolygonById(map, polygon_id)
        
        if (polygon) {
            // @ts-ignore
            return polygon.geometry.getCoordinates()[0]
        }

        return null
    }

    function createCluster(options?: any): any {
        return new window.ymaps.Clusterer(options)
    }

    function createPoint(
        coordinates: number[],
        options: Record<string, any>,
        properties: Record<string, any>
    ): ymaps.Placemark {
        return new window.ymaps.Placemark(coordinates, options, properties)
    }

    return {
        createPolygon,
        getPolygonCentroid,
        startUpdatePolygonByIndex,
        startUpdatePolygonById,
        stopUpdatePolygonByIndex,
        stopUpdatePolygonById,
        updatePolygonByIndex,
        removePolygonByIndex,
        getActualPolygonCoordinatesByIndex,
        getActualPolygonCoordinatesById,
        createCluster,
        createPoint,
    }
}
